import React, { createContext, useContext, useCallback } from "react";
import { site } from "../data/mock";

const DepositContext = createContext(null);

export const useDeposit = () => {
  const ctx = useContext(DepositContext);
  if (!ctx) throw new Error("useDeposit must be used within DepositProvider");
  return ctx;
};

// Booking is handled via WhatsApp. openDeposit(trip, extra) opens a prefilled chat.
export const DepositProvider = ({ children }) => {
  const openDeposit = useCallback((trip = null, extra = "") => {
    let msg = trip
      ? `Hi Hog Tide! I'd like to book the ${trip.name} ($${trip.price}).`
      : `Hi Hog Tide! I'd like to book a fishing trip.`;
    if (extra) {
      msg += `\n\n${extra}`;
    } else {
      msg += trip ? " Please help me pick an available date." : " Can you help me with dates and availability?";
    }
    window.open(`https://wa.me/${site.whatsapp}?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
  }, []);

  return (
    <DepositContext.Provider value={{ openDeposit }}>
      {children}
    </DepositContext.Provider>
  );
};
